import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import { ReactSVG } from 'react-svg';
import { download_icon, back_icon } from 'asset/icons';
import { DetailRow, SubmittedUserDropdown } from './components';
import AuditDetailPageFunctional from './index.function';
import { cn } from 'lib/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';

const AuditDetailPage = () => {
  const navigate = useNavigate();
  const params = useParams();

  const { audit_detail, setOpenIndex, openIndex, statusStyles } = AuditDetailPageFunctional(params);

  return (
    <Wrapper>
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>

        <Text text={`Audit # ${audit_detail?.auditId}`} size={fontSizes.h24} className='font-bold' />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6'>
        <div className='rounded-xl border bg-white p-5 pb-2 shadow-md'>
          <Text text='Audit Details' className='font-semibold mb-4' size={fontSizes.h16} />

          <DetailRow label='Audit Name' value={audit_detail?.auditName} />
          <DetailRow label='Customer' value={`${audit_detail?.customerName ?? '-'}`} />
          <DetailRow label='Assigned Auditor' value={audit_detail?.auditors ?? '-'} />
          <DetailRow
            label='Status'
            value={audit_detail?.auditStatus}
            valueClass={cn(
              'text-primary px-3 py-1 rounded-full text-xs',
              audit_detail?.auditStatus == 'Completed' ? 'bg-primary text-white' : 'bg-primary/20 text-primary',
            )}
            isBadge
          />
        </div>

        <div className='rounded-xl border bg-white p-5 pb-2 shadow-md'>
          <Text text='Overview' className='font-semibold mb-4' size={fontSizes.h16} />
          <DetailRow label='Rooms Audited' value='02' />
          <DetailRow label='Stores Audited' value='02' />
        </div>
      </div>

      <Text text='Reports' size={fontSizes.h22} className='font-bold mb-3' />

      <div className='rounded-xl border bg-white'>
        <Table>
          <TableHeader>
            <TableRow className='hover:bg-transparent'>
              <TableHead className='text-black px-4 py-3 min-w-32'>Report Type</TableHead>
              <TableHead className='text-black min-w-32'>Generated On</TableHead>
              <TableHead className='text-black min-w-24'>Format</TableHead>
              <TableHead className='text-black min-w-24'>Email Sent</TableHead>
              <TableHead className='text-black min-w-32'>Email Addresses</TableHead>
              <TableHead className='text-black min-w-24'>Status</TableHead>
              <TableHead className='text-black min-w-24'>Submitted by</TableHead>
              <TableHead className='text-black'>Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {audit_detail?.dailyReports?.map((report, index) => (
              <TableRow key={index}>
                <TableCell className='px-4 py-3'>
                  <Text text={report?.reportType} className='text-muted-foreground' />
                </TableCell>
                <TableCell>
                  <Text text={format(report?.reportDate, "MMM dd yyyy")} className='text-muted-foreground' />
                </TableCell>
                <TableCell>
                  <Text text={report?.format} className='text-muted-foreground' />
                </TableCell>
                <TableCell>
                  <Text text={report?.emailSent ? 'Yes' : 'No'} className='text-muted-foreground' />
                </TableCell>
                <TableCell>
                  <Text text={report?.submittedUserEmails} className='text-muted-foreground' />
                </TableCell>
                <TableCell>
                  <div
                    className={cn(
                      'px-3 py-1 rounded-full text-xs text-white flex items-center justify-center',
                      statusStyles[audit_detail?.auditStatus] || 'bg-gray-400'
                    )}
                  >
                    <Text text={audit_detail?.auditStatus} className="text-white text-center" />
                  </div>
                </TableCell>
                <TableCell className="relative">
                  <SubmittedUserDropdown
                    label={report?.submittedBy?.label}
                    users={report?.submittedBy?.users}
                    isOpen={openIndex === index}
                    onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                  />
                </TableCell>
                <TableCell>
                  <div
                    className={cn(
                      'flex items-center gap-1 text-primary',
                      report?.downloadUrl ? 'cursor-pointer' : 'opacity-40 cursor-not-allowed',
                    )}
                    onClick={() => {
                      if (report?.downloadUrl) {
                        const link = document.createElement('a');
                        link.href = report?.downloadUrl;
                        link.target = '_blank';
                        link.rel = 'noreferrer';
                        link.download = '';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }
                    }}
                  >
                    <Text text='Download' size={fontSizes.h13} className='text-primary' />
                    <ReactSVG src={download_icon} />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Wrapper>
  );
};

export default AuditDetailPage;
